import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import competenceImg from "../assets/images/competence.jpeg";

const gutterX = { xs: 2, sm: 3, md: 6, lg: 16 };

const Footer = () => {
    return (
        <Box sx={{
            backgroundColor: "#1B2F4A",//"243A5E",
            px: gutterX,
            py: 1, mt: 3 }}>
            {/* Footer start line */}

            <Grid container spacing={3} alignItems="stretch">
                {/* LEFT: 4 columns */}
                <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
                >
                    <Box

                        borderRadius={1}
                        component="img"
                        src={competenceImg}
                        alt="Illustration"
                        sx={{
                            filter: "brightness(0.95) saturate(0.7) hue-rotate(200deg)",
                            maxWidth: "70%", height: "auto", objectFit: "contain" }}
                    />
                </Grid>

                {/* RIGHT: QUOTE */}
                <Grid
                    item
                    xs={12}
                    md={8}
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Box
                        component="blockquote"
                        sx={{
                            m: 0,
                            width: "100%",
                            p: 1,
                            borderBottom: "2px solid #ddd",
                            borderRight: "2px solid #ddd",
                            borderTop: "2px solid #ddd",
                            borderRadius: 1,
                        }}
                    >
                        <Typography
                            sx={{
                                //fontFamily: '"Crimson Pro", serif',
                                fontWeight: 200,
                                lineHeight: 1.5,
                                color: '#D7E0EC   !important',
                            }}
                            variant="body2" >
                            Why bow thy head beneath the name of fraud?
                            Had Claude Elwood Shannon risen in this AI century
                            where thoughts fly swifter than breath and
                            information & entropy reckon faster than the pulse,
                            he too would stagger beneath excess of knowing.
                            Lost among glowing screens and infinite paths.

                            He would doubt, as thou dost now,
                            amid networks without end and truths summoned at a keystroke.
                            Yet from such doubt are new dominions seized.
                            For uncertainty is but the shadow
                            cast by a mind straining to outrun its tools
                            and shape the future they obey.<br/>
                            You owe thyself the luxury of locking in. <br/>
                            - Probably your super ego
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            <Box sx={{ borderTop: "1px solid #f5f5f5", mb: 2, mt: 2 }} />
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 2,
                    pt: 2,
                    mb:2
                }}
            >
                {/* LEFT: trademark */}
                <Typography variant="body2" sx={{color: '#D7E0EC   !important'}}>
                    © {new Date().getFullYear()} Aggrey Lelei.
                </Typography>

                {/* RIGHT GROUP */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: 2, md: 4 },
                    }}
                >
                    {/* Email link */}
                    <Typography
                        variant="body2"
                        component="a"
                        href="mailto:hello@aggreylelei.com"
                        sx={{
                            color: '#D7E0EC   !important',
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline",
                            },
                        }}
                    >
                        hello@aggreylelei.com
                    </Typography>

                    {/* Back to top */}
                    <Box
                        component="button"
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        sx={{
                            all: "unset",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: '#D7E0EC   !important',
                            "&:hover": {
                                opacity: 0.8,
                            },
                        }}
                    >
                        <span style={{ fontSize: "19px" }}>↑</span>
                        <Typography variant="body2" sx={{color: '#D7E0EC   !important'}}>Back to Top</Typography>

                    </Box>
                </Box>
            </Box>

        </Box>
    );
};

export default Footer;
